import React, { useContext, useRef, useState } from 'react'
import { ButtonHeading, FuelStationDetailsTab } from 'components';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import LoadingBar from 'react-top-loading-bar';
import Ledger from '../Ledger';
import FuelStatement from '../FuelStatement';
import { useLocation, useNavigate } from 'react-router-dom';
import useDocumentTitle from 'hooks/useDocumentTitle';
import { AdjustBalanceModal, FuelStationFundTransModal, PaymentConfirmModal, PaymentProcessingOffcanvas, PaymentStatusCard, PaymentSuccessOffcanvas } from 'modals';
import { UserContext } from 'context';

const FuelStationDetails = () => {
    useDocumentTitle("Fuel Station Details | T360");

    const location = useLocation();
    const navigate = useNavigate();
    const { setMasterDetailsList } = useContext(UserContext);
    const queryParams = new URLSearchParams(location.search);
    const stationName = queryParams.get('name') || '';
    const tabFromQuery = parseInt(queryParams.get('tab')) || 1;
    const [activeTab, setActiveTab] = useState(tabFromQuery);
    const [fuelData, setFuelData] = useState(null)
    const loadingBarRef = useRef(null)
    const [openLedgerModal, setOpenLedgerModal] = useState(false);
    const [refreshLedger, setRefreshLedger] = useState(false);
    const [ledgerDetails, setLedgerDetails] = useState({});
    const [isOpenFuelFund, setIsOpenFuelFund] = useState(false);
    const [eaesbuzzId, setEaesbuzzId] = useState({ eb_account_id: "", total_amount: 0 });
    const [isOpenPayNow, setIsOpenPayNow] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isSuccessOpen, setIsSuccessOpen] = useState(false);
    const [paymentData, setPaymentData] = useState({ voucher_id: "", data: {} });
    const [isMakeStatusOpen, setIsMakeStatusOpen] = useState(false);


    const handleActiveTabs = (e) => {
        setActiveTab(e);

        const params = new URLSearchParams(location.search);
        params.set('tab', e);
        navigate(`${location.pathname}?${params.toString()}`);
    }

    const tabProps = {
        tabList: constant.fuel_StationDetailsTabs,
        callBackTab: (e) => handleActiveTabs(e),
        activeTab: activeTab
    }

    const onDataFetch = (data) => {
        setFuelData(data)
    }

    const calback = () => {
        setOpenLedgerModal(false)
        setRefreshLedger(prev => !prev);
    }

    // ── Easebuzz Callback ────────────────────────────────────────
    const callbackEaesbuzz = (ebId, amount, venderDetails, payload) => {
        setEaesbuzzId((prev) => ({
            ...prev,
            eb_account_id: ebId,
            total_amount: amount,
            vendor_bank_account: venderDetails?.vendor_bank_account,
            payload,
        }));
    };

    const onShareReceipt = () => { };
    const viewReceiptHandle = (data) => setIsSuccessOpen(data);

    const handleDownloadReceipt = async () => {
    // try {
    //   const response = await fetch(`/api/receipt/${paymentData?.transactionId}`);
    //   const blob = await response.blob();
    //   const url = URL.createObjectURL(blob);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.download = `receipt_${paymentData?.transactionId}.pdf`;
    //   link.click();
    //   URL.revokeObjectURL(url);
    // } catch {
    //   alert('Failed to download receipt');
    // }
  };

    const doneHandle = () => {

        setIsOpenFuelFund(false);
        setIsOpenPayNow(false);
        setIsMakeStatusOpen(false);
    };

    // ✅ FIX: payment result pe bhi list refresh karo
    const paymentResult = (data, voucher_id) => {

        setIsOpenFuelFund(false);
        setIsProcessing(false);
        setIsOpenPayNow(false);
        setIsMakeStatusOpen(true);
        setPaymentData({ voucher_id, data });

    };

    const payNowProps = {
        isOpen: isOpenPayNow,
        closeModal: () => setIsOpenPayNow(false),
        setIsProcessing,
        setIsOpenPayNow,
        easebuzzDetails: eaesbuzzId,
    };


    let LedgerAdjustModalProps = {
        isOpen: openLedgerModal,
        closeModal: (e) => setOpenLedgerModal(false),
        modalMainClass: "_dashCommon_Modal _prtThemeModal _smModal",
        footerPart: false,
        approvalBtn: true,
        approvalBtnTxt: 'Send for Approval',
        modalTitle: "Adjust Balance",
        submitTitle: "Adjust Balance",
        detailsData: ledgerDetails,
        venderType: "Fuel Station",
        calback: calback
    }

    const addFundProps = {
        isOpen: isOpenFuelFund,
        closeModal: () => setIsOpenFuelFund(false),
        headerPart: false,
        footerPart: true,
        modalMainClass: "_dashCommon_Modal _lgModal",
        modalTitle: "Add Payment",
        submitTitle: "Add Payment",
        callbackEaesbuzz,
        setIsOpenPayNow,
        callBackFreight: () => {
        },
        details:fuelData
    };

    return (
        <div className=''>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />
            <ButtonHeading
                title={stationName ? stationName : (fuelData?.name ? fuelData?.name : 'Fuel Station')}
                buttonTitle="Back"
                isBackButton={true}
                onClickBackButton={() => { navigate('/account/fuel_station'); setMasterDetailsList({}) }} // navigate(-1)
                ledgerButtonTitle={activeTab == 2 ? "Adjust Balance" : ""}
                ledgerOnClick={() => setOpenLedgerModal(true)}
                fundButtonTitle="Transfer Fund"
                fundOnClick={()=>setIsOpenFuelFund(true)}
            />

            <div className='addPr_flBx commonDetails_bxs'>
                <Tab {...tabProps} />
                {activeTab === 1 && (
                    <FuelStationDetailsTab onDataFetch={onDataFetch} loadingBarRef={loadingBarRef} />
                )}
                {activeTab === 2 && <Ledger type={5} refresh={refreshLedger} setLedgerDetails={setLedgerDetails} />}
                {activeTab === 3 && <FuelStatement />}
                {openLedgerModal && <AdjustBalanceModal {...LedgerAdjustModalProps} />}
                {isOpenFuelFund && <FuelStationFundTransModal {...addFundProps} />}

                {isOpenPayNow && <PaymentConfirmModal {...payNowProps} />}

                {isProcessing?.selectedMethod && (
                    <PaymentProcessingOffcanvas
                        isOpen={isProcessing}
                        message="Please wait while we process your transaction..."
                        paymentResult={paymentResult}
                        eaesbuzzId={eaesbuzzId}
                        onClose={() => { setIsProcessing(false); setIsOpenPayNow(false); setIsOpenFuelFund(false); }}
                    />
                )}

                {isMakeStatusOpen && (
                    <PaymentStatusCard
                        isOpen={isMakeStatusOpen}
                        onClose={() => setIsMakeStatusOpen(false)}
                        paymentData={paymentData}
                        details={{ _id: paymentData?.data?.voucher_id }}
                        onShareReceipt={onShareReceipt}
                        viewReceiptHandle={viewReceiptHandle}
                        doneHandle={doneHandle}
                    />
                )}

                {isSuccessOpen && (
                    <PaymentSuccessOffcanvas
                        isOpen={isSuccessOpen}
                        onClose={() => setIsSuccessOpen(false)}
                        paymentData={paymentData}
                        onDownloadReceipt={handleDownloadReceipt}
                        onContactUs={() => alert('Contact support')}
                    />
                )}

                <div className={isSuccessOpen ? "offBack_drop" : ""} />

            </div>

        </div>
    )
}

export default FuelStationDetails;